import { SchoolActivityAttendee } from '../services/school-activity.service';
import { HallPass } from './HallPass';
import { Invitation } from './Invitation';
import { Request } from './Request';
import { SchoolActivity, SchoolActivityInstance } from './SchoolActivity';

export enum CalendarEventTypeEnum {
	ATTENDING = 'attending',
	SIGN_UP = 'sign_up',
	HALL_PASS = 'hall_pass',
	ACTIVITY = 'school_activity',
	ACTIVITY_INSTANCE = 'school_activity_instance',
	PASS_REQUEST = 'pass_request',
	PASS_INVITATION = 'pass_invitation',
}

export interface CalendarEventResponse {
	type: CalendarEventTypeEnum;
	start: Date;
	end: Date;
	title: string;
	allDay?: boolean;
	assigner_id?: number;
	hall_pass?: HallPass;
	flex_period_id?: number;
	flex_period_name?: string;
	location_id?: number;
	school_activity?: SchoolActivity;
	pass_request?: Request;
	pass_invitation?: Invitation;
	school_activity_instance?: SchoolActivityInstance;
	school_activity_attendee?: SchoolActivityAttendee;
}

export interface CalendarEventMeta {
	type: CalendarEventTypeEnum;
	height: string;
	duration?: number; // in minutes
	hallPass?: HallPass;
	flexPeriodId?: number;
	schoolActivity?: SchoolActivity;
	schoolActivityInstance?: SchoolActivityInstance;
	schoolActivityAttendee?: SchoolActivityAttendee;
	flexPeriodName?: string;
	activityId?: number;
	activityInstanceId?: number;
	assignerId?: number;
	preventStudentOpeningMsg?: string;
	locationId?: number;
	pass_request?: Request;
	pass_invitation?: Invitation;
	displayStartTime: Date;
	displayEndTime: Date;
	background?: string;
	borderColor?: string;
	eventTitleFontColor?: string;
	eventTimeFontColor?: string;
	isMissed?: boolean;
	isActiveHallPass?: boolean;
	isEndedHallPass?: boolean;
	isOvertime?: boolean;
	isPendingScheduledPass?: boolean;
	hideProfileImg?: boolean;
}
